module.exports = ".folded:not(.unfolded) :host .nav-link > .nav-link-title,\n.folded:not(.unfolded) :host .nav-link > .nav-link-badge {\n  opacity: 0;\n  -webkit-transition: opacity 200ms ease;\n  transition: opacity 200ms ease; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module id = ./src/@fuse/components/navigation/vertical/nav-item/nav-vertical-item.component.scss
// module chunks = main